import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import {CoreService} from "../services/core.service";
import {PageNumber, PageSize} from "../shared/variables/variables";

@Injectable({
  providedIn: 'root'
})
export class PassedUsersResolver implements Resolve<boolean> {
  constructor(private coreService: CoreService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.coreService.getRequest(`admin/passed-users?limit=${PageSize}&page=${PageNumber}`);
  }
}
